
import React, { Component } from 'react';
import ThirdCom from '../ThirdCom';

/**
 * 模板导出
 */
class ExcelOutput extends Component {

    state = { showExcelOutput: this.props.showExcelOutput }

    static defaultProps = { showExcelOutput: false }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let { showExcelOutput } = nextProps;
        if (showExcelOutput !== this.state.showExcelOutput) {
            this.setState({ showExcelOutput: showExcelOutput });
        }
    }

    closeExceloutModalEvent = () => {
        let { closeExceloutModal } = this.props;
        if (typeof closeExceloutModal === "function") {
            closeExceloutModal();
        }
        this.setState({ showExcelOutput: false });
    }

    render() {
        let { showExcelOutput } = this.state;
        return <ThirdCom
            {...this.props}
            closeExceloutModal={this.closeExceloutModalEvent}
            showThirdComponent={showExcelOutput}
            componentNameSpace="uap/common/components/ExcelOutput2Platform/index"
            componentPath="../../../../uap/common/components/ExcelOutput2Platform/index.js"
            componentName='模板导出'
        />;
    }
}

export default ExcelOutput;
